import { StyledAccordionActions } from './style';

export default function ActionItemFooter({ children }) {
  return <StyledAccordionActions data-cy="ai-footer">{children}</StyledAccordionActions>;
}
